import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  changePassword,
  type PasswordChangeRequest,
  type PasswordChangeResponse,
} from "../api/account.api";
import { accessKeysKeys } from "./useAccessKeys";
import { cliKeys } from "@/features/cli/hooks/useCli";
import { ApiError } from "@/lib/api/client";

/**
 * The change signs out the other browser sessions and voids pending CLI sign-in
 * requests, both of which the account page lists, so their queries are refreshed.
 */
export function useChangePassword() {
  const queryClient = useQueryClient();

  return useMutation<PasswordChangeResponse, ApiError, PasswordChangeRequest>({
    mutationFn: changePassword,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: accessKeysKeys.all });
      queryClient.invalidateQueries({ queryKey: cliKeys.all });
    },
  });
}
